import '@fontsource/herr-von-muellerhoff/latin-400.css'
import { X } from 'lucide-react'

import { cn } from '@/lib/utils'

/** A typed name drawn as a pen signature on a signing line; the quote PDF signs in the same face. */
export function SignatureMark({ name, className }: { name: string; className?: string }) {
  return (
    <div
      className={cn(
        'relative flex min-h-20 items-end border-b border-slate-400 px-1 pb-1',
        className,
      )}
    >
      <X aria-hidden="true" className="text-muted-foreground absolute bottom-2 left-0 size-3.5" />
      <span
        className={cn(
          'font-signature min-w-0 truncate pl-5 text-[2.75rem] leading-[1.35] text-[#0b2545]',
          !name && 'text-muted-foreground/50',
        )}
      >
        {name || 'Your signature'}
      </span>
    </div>
  )
}
